import { Component } from 'preact';
import style from './styles/SelectInput.scss';
import { CustomInput, FormGroup } from 'reactstrap';
import SlideDownReveal from '../effects/SlideDownReveal';

/**
 * @property {string} props.name
 * @property {string} props.label
 * @property {Function} props.onChangeAction
 * @property {boolean} props.required
 * @property {string} props.value
 * @property {SelectOption[]} props.options
 * @property {string} props.className
 */
export default class SelectInput extends Component {

	static getDefaultValues() {
		return {
			value: null,
			touched: false
		};
	}

	state = {
		open: false
	};

	/**
	 * Validates when input looses focus
	 *
	 * @param {Event} event
	 * @this SelectInput
	 */
	onChange = (event) => {
		const value = event.target.value;
		const option = this.props.options.find(option => option.value === value);
		this.props.onChangeAction(this.props.name, {
			value,
			touched: true
		}, option ? option : null);
		this.setState({
			open: false
		});
	};

	/**
	 * Make sure placeholder is hidden
	 *
	 * @param {Event} event
	 * @this SelectInput
	 */
	onMouseDown = (event) => {
		this.setState({
			open: true
		});
	};

	/**
	 * Make sure placeholder is hidden
	 *
	 * @param {Event} event
	 * @this SelectInput
	 */
	onBlur = (event) => {
		this.setState({
			open: false
		});
	};

	constructor(props) {
		const { onChangeAction } = props;
		if (!(onChangeAction instanceof Function)) {
			new Error('SelectInput expects onChangeAction prop to be a defined Function.');
		}
		super(props);
	}

	/**
	 * @param {SelectOption} option
	 * @param {string} value
	 */
	renderOption = (option, value) => <option {...{ value: option.value, selected: option.value === value }}>{option.label}</option>;

	render({ name, placeholder, required, options, value = '', className, parentWasValidated, invalidMessage, touched, disabled }, { open }) {
		const noValueSelected = value === '';
		const showPlaceholder = noValueSelected;
		const requiredAndNoValueSelected = required && noValueSelected;
		const valid = touched && !requiredAndNoValueSelected;
		const invalid = (touched || parentWasValidated) && requiredAndNoValueSelected;
		return (
			<FormGroup className={`${style['select-wrapper']} ${className}`}>
				<CustomInput type="select" className={`${style.select}`} {...{ name, required, onChange: this.onChange, onMouseDown: this.onMouseDown, onBlur: this.onBlur, valid, invalid, disabled }}>
					{placeholder ? <option {...{ selected: noValueSelected, value: ''  }} /> : null }
					{options.length !== 0 && options.map((option) => this.renderOption(option, value))}
				</CustomInput>
				<span className={style.placeholder + (showPlaceholder && !open ? ` ${style.visible}` : '')}>{placeholder}</span>
				<SlideDownReveal visible={invalid} timeout={300} appear>
					<div className="invalid-feedback">
						{invalidMessage}
					</div>
				</SlideDownReveal>
			</FormGroup>
		);
	}
}



// WEBPACK FOOTER //
// ./components/form/SelectInput.js